<template>
  <div id="app">
    <navbar @logout="logout"></navbar>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import NavBar from './components/NavBar'
import { clearSession } from './mixins/auth'
import { Store } from './store'

export default {
  components: {
    navbar: NavBar
  },
  methods: {
    logout () {
      // Logout of backend and then clear local state
      clearSession().then(() => {
        Store.clear()
        this.$router.replace('/')
      })
    }
  }
}

</script>

<style>
@import "assets/vendor/bootstrap/bootstrap.min.css";
@import "assets/styles/base.css";

</style>
